import PropTypes from 'prop-types';
import React from 'react';
import $ from 'jquery';

class Popup extends React.Component {
  static displayName = 'Popup';

  static propTypes = {
    content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    target: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    on: PropTypes.string,
    position: PropTypes.string,
    identifier: PropTypes.string,
    onPopupClose: PropTypes.func,
    onPopupOpen: PropTypes.func,
  };

  static defaultProps = {
    on: 'focus',
    position: 'bottom left',
    identifier: 'popup-1',
  };

  componentDidMount() {
    const { target, on, position, identifier, onPopupClose, onPopupOpen } =
      this.props;
    $(target).popup({
      inline: true,
      on,
      position,
      popup: `.ui.popup.Popup.${identifier}`,
      onHide: () => onPopupClose?.(),
      onShow: () => onPopupOpen?.(),
    });
  }

  render() {
    const { identifier, content, reference } = this.props;
    const className = `ui popup Popup ${identifier}`;
    return (
      <div
        aria-label="Extra activities/services offered. Available during checkout."
        ref={reference}
        tabIndex="-1"
        data-toggle="tooltip"
        className={className}
      >
        {content}
      </div>
    );
  }
}

export default Popup;
